import { request } from "common";
export function appBasic(params) {
  return request({
    url: "/portal/api/v1/appCenter/appBasicInfoConfig",
    method: "get",
    params: params,
  });
}
